import React from 'react';
import { Images } from '../../config/images';
import { CloseIcon } from '../../assets/icons';
import './NoSearchResult.scss';
import { useSelector } from 'react-redux';
import { LazyLoadImage } from 'react-lazy-load-image-component';

const NoSearchResult = (props) => {
  const filterApply = useSelector((state) => state.filters.filterApply);
  const { isSecondary, title, description, filterText, handleRemoveLeverage, handleRemoveLocationFilter, handleClearAll } = props;
  return (
    <div className='no-data-found'>
      <div className='no-data-found-wrap'>
        <div className='mb-32 vector__icon'>
          <LazyLoadImage src={Images.home} alt='success vector art' />
        </div>
        <h4 className='title mb-16'>
          {!filterApply ? 
            isSecondary ? 
              'Realbricks Market coming soon' : 
              'No property found' : 
            title
          }
        </h4>
        {filterApply && <>
          <p className='text-taupe mb-0'>{description}</p>
          <hr className='mt-40 mb-40' />
          <p className='mb-16 text-taupe'>{filterText}</p>
          <div className='remove__filters'>
            <div className='remove__filters__button' onClick={handleRemoveLeverage}>
              <CloseIcon size={24} color='#4F3D38' />
              <span className='fz-16 text-taupe fw-600'>Remove Leverage filters</span>
            </div>
            <div className='remove__filters__button' onClick={handleRemoveLocationFilter}>
              <CloseIcon size={24} color='#4F3D38' />
              <span className='fz-16 text-taupe fw-600'>Remove Location filters</span>
            </div>
          </div>
          {/* <Button onClick={handleClearAll} type='link'>
            Clear all
          </Button> */}
          <span className='fz-16 fw-600 text-copper cursor-pointer' onClick={handleClearAll}>
            Clear all
          </span>
        </>}
      </div>
    </div>
  );
};
export default NoSearchResult;
